import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ROUTE_FEATURE, makeHasFeature } from "@/lib/tiers";
import UpgradePrompt from "@/components/UpgradePrompt";

// Guards page content: if the current route needs a feature the tenant's tier
// doesn't include, show the upgrade prompt instead of the page.
export default function GatedOutlet() {
  const { org, user } = useAuth();
  const loc = useLocation();
  const feature = ROUTE_FEATURE[loc.pathname];
  const hasFeature = makeHasFeature(org, user);
  if (feature && !hasFeature(feature)) return <UpgradePrompt feature={feature} />;
  return <Outlet />;
}
